<template>
  <div>
    <van-nav-bar title="说明" :fixed="true" />
    <div class="standardLimits">
      <van-cell title="标准限值" is-link @click="$router.push({name: 'standardLimits'})">
        <!-- <template #icon>
          <van-icon name="search" style="line-height: inherit;" />
        </template> -->
      </van-cell>
      <van-cell title="关于" is-link @click="$router.push({name: 'about'})">
        <!-- <template #icon>
          <van-icon name="search" style="line-height: inherit;" />
        </template> -->
      </van-cell>
    </div>
  </div>
</template>

<script>
export default {
  name: "standardLimits",
  data() {
    return {

    };
  },
  methods: {
    goback() {
      window.history.back();
    },

  }
};
</script>

<style scoped>
.standardLimits {
  padding-top: 15px;
}
.standardLimits h5 {
  text-align: center;
}
.limitTable {
  width: 354px;
  margin: 0 auto;
  /* padding: 10px; */
}
.limitTable table {
  width: 100%;
}
.limitTable table thead {
  /* display: flex; */
}
</style>


// WEBPACK FOOTER //
// src/pages/application/explanation.vue